import type { ReactNode } from 'react';

interface ContainerProps {
  children: ReactNode;
  /** По умолчанию max-w-5xl. `wide` — для таблиц, `narrow` — для длинных списков (профиль). */
  width?: 'narrow' | 'default' | 'wide';
}

// Единая обёртка содержимого страниц: горизонтальный padding и
// max-width. Сделана отдельным компонентом, чтобы будущие правки
// (sidebar offset, breakpoints) шли в одном месте.
export function PageContainer({ children, width = 'default' }: ContainerProps) {
  const w =
    width === 'narrow' ? 'max-w-2xl' : width === 'wide' ? 'max-w-6xl' : 'max-w-5xl';
  return <div className={`mx-auto ${w} px-6 py-6`}>{children}</div>;
}

interface HeaderProps {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

// Шапка страницы: h1 + опциональное описание + действие справа.
export function PageHeader({ title, description, action }: HeaderProps) {
  return (
    <header className="mb-6 flex items-start justify-between gap-4">
      <div className="min-w-0">
        <h1 className="text-xl font-semibold text-slate-900">{title}</h1>
        {description && (
          <p className="mt-1 text-sm text-slate-500">{description}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </header>
  );
}
